// src/redux/reducers/index.ts
import { combineReducers } from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import currencyReducer from './currency/reducer';
import languageReducer from './language/reducer'; // Importa el reducer de idioma

export default combineReducers({
  Auth,
  Layout,
  currency: currencyReducer,
  language: languageReducer, // Inclúyelo aquí
});


